import { Link } from "react-router-dom";
import { Check, Lock, ArrowRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export default function Timeline({ weeks, currentWeek, onSetCurrent, isTeacher }) {
  return (
    <div className="bg-white rounded-3xl p-6 border border-slate-200 shadow-sm">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-outfit text-2xl sm:text-3xl font-bold tracking-tight">10-Week Timeline</h2>
          <p className="text-sm text-slate-500">From algorithms to AI exhibition.</p>
        </div>
      </div>

      <div className="timeline-scroll overflow-x-auto pb-3 -mx-2 px-2">
        <div className="flex gap-4 min-w-max">
          {weeks.map((w, idx) => {
            const isDone = w.week_num < currentWeek;
            const isCurrent = w.week_num === currentWeek;
            const isExhibition = w.week_num === 10;

            const base = "relative w-64 flex-shrink-0 rounded-2xl p-5 border transition group";
            let style = "bg-white border-slate-200 hover:border-slate-300";
            if (isDone) style = "bg-emerald-50 border-emerald-200";
            if (isCurrent) style = "bg-yellow-50 border-yellow-300 ring-2 ring-yellow-300";
            if (isExhibition && !isDone) style = "bg-gradient-to-br from-pink-50 to-amber-50 border-amber-200";

            return (
              <motion.div
                key={w.week_num}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: idx * 0.04 }}
                className={`${base} ${style}`}
                data-testid={`timeline-week-${w.week_num}`}
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-bold tracking-wider uppercase text-slate-500">Week {w.week_num}</span>
                  {isDone ? (
                    <span className="w-6 h-6 rounded-full bg-emerald-500 text-white flex items-center justify-center">
                      <Check weight="bold" size={14} />
                    </span>
                  ) : isCurrent ? (
                    <span className="text-[10px] font-bold tracking-wider uppercase bg-yellow-400 text-yellow-950 px-2 py-0.5 rounded-full">
                      Now
                    </span>
                  ) : (
                    <Lock size={14} className="text-slate-400" />
                  )}
                </div>
                <h3 className="font-outfit font-bold text-lg leading-tight mb-1">{w.title}</h3>
                <p className="text-xs text-slate-500 mb-4 line-clamp-2">{w.tagline}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[11px] text-slate-500">{w.category}</span>
                  <Link
                    to={`/week/${w.week_num}`}
                    data-testid={`timeline-open-${w.week_num}`}
                    className="text-xs font-semibold text-slate-900 inline-flex items-center gap-1 group-hover:underline"
                  >
                    Open <ArrowRight weight="bold" size={12} />
                  </Link>
                </div>
                {isTeacher && !isCurrent && (
                  <button
                    onClick={() => onSetCurrent(w.week_num)}
                    data-testid={`timeline-set-current-${w.week_num}`}
                    className="mt-3 w-full text-xs font-semibold py-1.5 rounded-lg bg-slate-900 text-white hover:bg-slate-800"
                  >
                    Set as current week
                  </button>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
